import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <p className="font-label text-[11px] uppercase tracking-[0.3em] text-primary-300">404 · Page not found</p>
      <h1 className="mt-4 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">这个页面不存在</h1>
      <p className="mt-3 text-[13px] text-foreground-500">你访问的地址可能已经被移除，或者链接输入有误。</p>
      <p className="mt-2 font-mono text-[11px] text-foreground-500">{location.pathname}</p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-[13px] text-background-50 transition-colors hover:bg-primary-500"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/search?q="
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-5 py-2.5 text-[13px] text-foreground-700 transition-colors hover:border-primary-500 hover:text-primary-200"
        >
          <i className="ri-search-line"></i>
          搜索影片
        </Link>
      </div>
    </div>
  );
}